import React, { Component } from 'react'
import SectionHeading from '../common/SectionHeading'
import Colors from '../../../themes/Colors'
import { ResponsiveContainer } from '../common/styledComponents'
import {
  IbCricketHostingSectionContainer,
  LogoInnerContainer,
  Logo,
  LogosWrapper,
  Description,
  BottomText
} from './styledComponents'

class IbCricketHostingSection extends Component {
  renderHostedCompaniesList = hostedList => (
    <LogosWrapper>
      {hostedList.map(logo => (
        <LogoInnerContainer key={logo.imageUrl}>
          <Logo src={logo.imageUrl} />
        </LogoInnerContainer>
      ))}
    </LogosWrapper>
  )

  render() {
    const { eventsHostedAtHeader } = this.props
    const {
      eventsHostedAtHeaderHeading,
      hostedList,
      footerDescription,
      bottomDescription
    } = eventsHostedAtHeader

    return (
      <IbCricketHostingSectionContainer id="ibCricketHostedAtSection">
        <ResponsiveContainer>
          <SectionHeading
            sectionHeadingText={eventsHostedAtHeaderHeading}
            color={Colors.pumpkinOrange}
          />
          {this.renderHostedCompaniesList(hostedList)}
          <Description
            dangerouslySetInnerHTML={{
              __html: footerDescription
            }}
            as="p"
          />
          <BottomText>{bottomDescription}</BottomText>
        </ResponsiveContainer>
      </IbCricketHostingSectionContainer>
    )
  }
}
export default IbCricketHostingSection



// WEBPACK FOOTER //
// ./src/components/Events/IbCricketHostingSection/index.js